module.exports = __webpack_public_path__ + "img/1 - Louis Lotter.63b5c35f.jpg";